import React, { Component } from 'react';
import { Router } from '@reach/router';
import SmoothScroll from 'smooth-scroll';
import _ from 'lodash';

import AllLocations from './components/all-locations';
import Results from './components/results';

import { BASE_PATH, RADIUS_SEARCH } from './globals/wp';
import { RADIUS_OPTIONS } from "./globals/config";

export default class routes extends Component {

	constructor (props) {
		super(props);
		this.scrollPosition = 0;
		this.firstViewSeen = false;

		const radiusObject = _.find(RADIUS_OPTIONS, {value: parseInt(RADIUS_SEARCH, 10)});
		const startRadius = radiusObject ? radiusObject.value : RADIUS_OPTIONS[0].value;
		this.state = {
			radius: startRadius.toString(),
		};
	}

	componentWillMount() {
		document.addEventListener('modern_tribe/locator/region_click', this.handleRegionClick);
		document.addEventListener('modern_tribe/locator/all_locations_mount', this.handleAllLocationsMount);
		document.addEventListener('modern_tribe/locator/update_radius', this.handleStateRadiusChange);
	}

	componentWillUnmount() {
		document.removeEventListener('modern_tribe/locator/region_click', this.handleRegionClick);
		document.removeEventListener('modern_tribe/locator/all_locations_mount', this.handleAllLocationsMount);
		document.removeEventListener('modern_tribe/locator/update_radius', this.handleStateRadiusChange);
	}

	/**
	 * @function handleStateRadiusChange
	 * @description used to pass the radius into the All Locations view
	 */
	handleStateRadiusChange = (e) => {
		this.setState({
			radius: e.detail.radius.toString(),
		});
	};

	handleRegionClick = () => {
		this.scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
		// scroll to the top
		const scroll = new SmoothScroll();
		const anchor = document.querySelector('#locator-app');
		if (anchor) {
			scroll.animateScroll(
				anchor,
				true,
				{
					updateURL: false,
					popstate: false,
					offset: () => {
						let nodes = document.querySelectorAll('[data-js="site-header"]');
						if (nodes[0]) {
							return nodes[0].offsetHeight;
						}
						return 0;
					}
				}
			);
		}
	};

	handleAllLocationsMount = () => {
		if (this.firstViewSeen) {
			window.scrollTo(0, this.scrollPosition); // scroll back
		}
		this.firstViewSeen = true;
	};

	render () {
		return (
			<Router primary={false}>
				<AllLocations path={BASE_PATH} stateRadius={this.state.radius} />
				<Results path={`${BASE_PATH}location/:lat/:lng/:country/:state/:type/:query/:radius/`} />
			</Router>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes.js